export interface MinuteOption {
  displayText: string;
  dayMinute: number;
}

export function minuteOptions(
  granularity: number,
  min: number,
  max: number,
): MinuteOption[] {
  const options = [];
  for (let t = min; t <= max; t += granularity) {
    options.push({
      dayMinute: t,
      displayText: localTimeString(t),
    });
  }
  return options;
}

export function addExtraMinuteOption(
  options: MinuteOption[],
  dayMinute: number,
): MinuteOption[] {
  return [
    ...options,
    { dayMinute, displayText: localTimeString(dayMinute) },
  ].sort((a, b) => a.dayMinute - b.dayMinute);
}

function localTimeString(dayMinute: number): string {
  const h = Math.floor(dayMinute / 60);
  const m = dayMinute % 60;
  return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
}
